<template>
  <div class="admin-CA-setting">

    <div class="header">
      <h2>보상예시 관리</h2>
      <button @click="openCreateModal" class="btn-primary">새로 만들기</button>
    </div>
    
    <div class="content">
      <ul>
        <li class="chapter">
          <span>이름</span>
          <span>코드</span>
          <span>순서</span>
          <span>상태</span>
          <span>생성일</span>
          <span>수정일</span>
          <span>작업</span>
        </li>
        <template v-for="ex in benefitEx" :key="ex.idx">
          <li>
            <span>{{ ex.name }}</span>
            <span>{{ ex.code }}</span>
            <span>{{ ex.no }}</span>
            <span>{{ ex.status === 1 ? '활성' : '비활성' }}</span>
            <span>{{ formatDate(ex.created_at) }}</span>
            <span>{{ formatDate(ex.updated_at) }}</span>
            <span class="actions">
              <button @click="viewItem(ex)" class="btn-view">보기</button>
              <button @click="editItem(ex)" class="btn-edit">수정</button>
              <button @click="deleteItem(ex)" class="btn-delete">삭제</button>
            </span>
          </li>
        </template>
      </ul>
    </div>

    <!-- View Modal -->
    <div v-if="showViewModal" class="modal-overlay" @click="closeModals">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>보상예시 상세</h3>
          <button @click="closeModals" class="btn-close">×</button>
        </div>
        <div class="modal-body">
          <div class="view-field">
            <label>이름:</label>
            <span>{{ currentItem.name }}</span>
          </div>
          <div class="view-field">
            <label>코드:</label>
            <span>{{ currentItem.code }}</span>
          </div>
          <div class="view-field">
            <label>순서:</label>
            <span>{{ currentItem.no }}</span>
          </div>
          <div class="view-field">
            <label>상태:</label>
            <span>{{ currentItem.status === 1 ? '활성' : '비활성' }}</span>
          </div>
          <div class="view-field">
            <label>생성일:</label>
            <span>{{ formatDate(currentItem.created_at) }}</span>
          </div>
          <div class="view-field">
            <label>수정일:</label>
            <span>{{ formatDate(currentItem.updated_at) }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModals" class="btn-secondary">닫기</button>
        </div>
      </div>
    </div>

    <!-- Edit/Create Modal -->
    <div v-if="showEditModal" class="modal-overlay" @click="closeModals">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>{{ isEditMode ? '보상예시 수정' : '보상예시 생성' }}</h3>
          <button @click="closeModals" class="btn-close">×</button>
        </div>
        <div class="modal-body">
          <div class="form-field">
            <label>이름:</label>
            <input v-model="editForm.name" type="text" placeholder="이름을 입력하세요" />
          </div>
          <div class="form-field">
            <label>코드:</label>
            <input v-model="editForm.code" type="text" placeholder="코드를 입력하세요" />
          </div>
          <div class="form-field">
            <label>순서:</label>
            <input v-model="editForm.no" type="number" placeholder="순서를 입력하세요" />
          </div>
          <div class="form-field">
            <label>상태:</label>
            <select v-model.number="editForm.status">
              <option :value="1">활성</option>
              <option :value="0">비활성</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModals" class="btn-secondary">취소</button>
          <button @click="saveItem" class="btn-primary">{{ isEditMode ? '수정' : '생성' }}</button>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import { ref, inject, onMounted } from 'vue';

export default {
  name: 'adminCAbenefitEx',
  setup() {
    const benefitEx = ref([]);
    const sql_query = inject('sql_query');
    const showViewModal = ref(false);
    const showEditModal = ref(false);
    const isEditMode = ref(false);
    const currentItem = ref({});
    const editForm = ref({
      name: '',
      code: '',
      no: 0,
      status: 1
    });

    async function getBenefitEx() {
      const res = await sql_query('SELECT * FROM benefit_ex ORDER BY no ASC');
      benefitEx.value = res;
    }

    function formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('ko-KR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }

    function viewItem(item) {
      currentItem.value = { ...item };
      showViewModal.value = true;
    }

    function editItem(item) {
      isEditMode.value = true;
      currentItem.value = { ...item };
      editForm.value = {
        name: item.name,
        code: item.code,
        no: item.no,
        status: item.status
      };
      showEditModal.value = true;
    }

    function openCreateModal() {
      isEditMode.value = false;
      editForm.value = {
        name: '',
        code: '',
        no: benefitEx.value.length + 1,
        status: 1
      };
      showEditModal.value = true;
    }

    async function saveItem() {
      try {
        if (isEditMode.value) {
          let sql = `UPDATE benefit_ex SET name = '${editForm.value.name}', code = '${editForm.value.code}', no = '${editForm.value.no}', status = '${editForm.value.status}', updated_at = NOW() WHERE idx = '${currentItem.value.idx}'`;
          await sql_query(sql);
        } else {
          let sql = `INSERT INTO benefit_ex (name, code, no, status, created_at, updated_at) VALUES ('${editForm.value.name}', '${editForm.value.code}', '${editForm.value.no}', '${editForm.value.status}', NOW(), NOW())`;
          await sql_query(sql);
        }
        await getBenefitEx();
        closeModals();
      } catch (error) {
        console.error('Error saving item:', error);
        alert('저장 중 오류가 발생했습니다.');
      }
    }

    async function deleteItem(item) {
      if (!confirm(`"${item.name}"을(를) 삭제하시겠습니까?`)) {
        return;
      }
      try {
        await sql_query(`DELETE FROM benefit_ex WHERE idx = ?`, [item.idx]);
        await getBenefitEx();
      } catch (error) {
        console.error('Error deleting item:', error);
        alert('삭제 중 오류가 발생했습니다.');
      }
    }

    function closeModals() {
      showViewModal.value = false;
      showEditModal.value = false;
      currentItem.value = {};
    }

    onMounted(() => {
      getBenefitEx();
    })
  
    return {
      benefitEx,
      showViewModal,
      showEditModal,
      isEditMode,
      currentItem,
      editForm,
      formatDate,
      viewItem,
      editItem,
      openCreateModal,
      saveItem,
      deleteItem,
      closeModals
    }
  }
}
</script>


<style scoped>
.admin-CA-setting {
  width:100%;
  height: 100%;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background-color: var(--color-background);
}

.admin-CA-setting > .header { 
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.content {
  width:100%;
  height:100%;
  flex:1;
  padding:16px;
  box-sizing: border-box;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:16px;
  overflow: auto;
}

.content > ul {
  width:100%;
  padding:0;
  margin:0;
  list-style: none;
  display:flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap:0;
}

.content > ul > li {
  width:100%;
  min-height:60px;
  display:flex;
  justify-content: start;
  align-items: center;
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-surface-reverse);
  padding:16px;
  box-sizing: border-box;
}

.content > ul > li.chapter {
  background: var(--color-background-light);
  font-weight: 600;
}

.content > ul > li > span {
  flex:1;
  min-width: 100px;
}

.content > ul > li > span.actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* Buttons */
.btn-primary, .btn-secondary, .btn-view, .btn-edit, .btn-delete, .btn-close {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-primary:hover {
  background-color: #45a049;
}

.btn-secondary {
  background-color: #757575;
  color: white;
}

.btn-secondary:hover {
  background-color: #616161;
}

.btn-view {
  background-color: #2196F3;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
}

.btn-view:hover {
  background-color: #0b7dda;
}

.btn-edit {
  background-color: #FF9800;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
}

.btn-edit:hover {
  background-color: #e68900;
}

.btn-delete {
  background-color: #f44336;
  color: white;
  padding: 6px 12px;
  font-size: 12px;
}

.btn-delete:hover {
  background-color: #da190b;
}

.btn-close {
  background: none;
  color: var(--color-text-primary);
  font-size: 24px;
  padding: 0;
  width: 32px;
  height: 32px;
}

.btn-close:hover {
  background-color: rgba(0,0,0,0.1);
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--color-background);
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--color-surface-reverse);
}

.modal-header h3 {
  margin: 0;
  color: var(--color-text-primary);
}

.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 20px;
  border-top: 1px solid var(--color-surface-reverse);
}

/* View Fields */
.view-field {
  display: flex;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid var(--color-surface-reverse);
}

.view-field label {
  font-weight: 600;
  color: var(--color-text-primary);
  min-width: 100px;
}

.view-field span {
  color: var(--color-text-primary);
}

/* Form Fields */
.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field label {
  font-weight: 600;
  color: var(--color-text-primary);
}

.form-field input,
.form-field select {
  padding: 10px;
  border: 1px solid var(--color-surface-reverse);
  border-radius: 4px;
  background-color: var(--color-background);
  color: var(--color-text-primary);
  font-size: 14px;
}

.form-field input:focus,
.form-field select:focus {
  outline: none;
  border-color: #4CAF50;
}
</style>